var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creationCompetitionSucceed"},[_vm._m(0),_c('div',{staticClass:"getBack"},[_c('el-button',{staticClass:"getBackBtn",on:{"click":_vm.toStoreCustomer}},[_vm._v("返回")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creationCompetitionSucceed-icon"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('span',[_vm._v("操作成功!")])])
}]

export { render, staticRenderFns }